import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { Observable, catchError, EMPTY, tap } from 'rxjs';
import { ApiService } from '../services/api.service';
import { Data } from '../models/article-detail.model';
import { UtilityService } from '../services/utility.service';
import { webRedirectionUrl } from '../constants/web-redirection-url';
import { NavigationService } from '../services/navigation.service';
import { AnalyticsService } from '../services/analytics.service';

export const articleDetailResolver: ResolveFn<Observable<Data>> = (
  route: ActivatedRouteSnapshot,
) => {
  const articleId: string = route.params['id'].split('.html')[0];
  const apiService = inject(ApiService);
  const utilityService = inject(UtilityService);
    const navigationService = inject(NavigationService)
  const analyticsService = inject(AnalyticsService);

  if (utilityService.isUserLoggedIn()) {
    const url = `${webRedirectionUrl.articleDetails}${articleId}`;
    utilityService.saveUrlandRedirect(url);
    return EMPTY;
  } else {
    return apiService.fetchArticleDetail(articleId).pipe(
      tap((data) => {
        const article = data as any;
        analyticsService.logEvent('article_view', {
          id: article?.id,
          title: article?.title,
        });
      }),
      catchError((error) => {
       navigationService.handleResolverError(error)
        return EMPTY;
      }),
    );
  }
};
